// Mock data for Cyber-Wiz cybersecurity website

export const mockServices = [
  {
    id: 1,
    title: "Vulnerability Management as a Service",
    description: "Comprehensive vulnerability scanning, assessment, and remediation planning to protect your infrastructure from emerging threats.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Risk Management & Assessment",
    description: "Strategic risk evaluation and mitigation planning tailored to your business objectives and compliance requirements.",
    icon: "AlertTriangle"
  },
  {
    id: 3,
    title: "Penetration Testing",
    description: "Advanced ethical hacking and security testing to identify vulnerabilities before malicious actors do.",
    icon: "Target"
  },
  {
    id: 4,
    title: "CMMC Readiness & Audit",
    description: "Cybersecurity Maturity Model Certification preparation and audit support for defense contractors.",
    icon: "CheckCircle"
  },
  {
    id: 5,
    title: "PCI DSS Audit & Support",
    description: "Payment Card Industry Data Security Standard compliance assessment and ongoing support.",
    icon: "CreditCard"
  },
  {
    id: 6,
    title: "Third-Party Security Audits",
    description: "Independent security assessments and vendor risk evaluations to ensure supply chain security.",
    icon: "Users"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CISO, TechCorp Industries",
    content: "Cyber-Wiz transformed our security posture completely. Their vulnerability management service identified critical gaps we never knew existed.",
    avatar: "SC"
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    role: "IT Director, Defense Solutions",
    content: "The CMMC readiness program was exceptional. We achieved certification on the first attempt thanks to their thorough preparation.",
    avatar: "MR"
  },
  {
    id: 3,
    name: "Dr. Emily Watson",
    role: "Security Lead, FinanceSecure",
    content: "Their penetration testing revealed vulnerabilities that could have cost us millions. Professional, thorough, and incredibly knowledgeable.",
    avatar: "EW"
  }
];

export const mockContactSubmission = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  console.log('Mock contact form submission:', formData);
  
  // Simulate successful submission
  return {
    success: true,
    message: "Thank you for reaching out! We'll contact you within 24 hours."
  };
};